import FooterMenuList, { FooterMenuListProps } from './FooterMenuList';

export type { FooterMenuListProps };
export default FooterMenuList;
